import { FC, useEffect, useRef } from 'react'
import { co2LevelsOrgStyle } from './CO2LevelsOrg.style'

/**
 * CO2LevelsOrgProps contains properties for the component.
 */
export interface CO2LevelsOrgProps {} // eslint-disable-line @typescript-eslint/no-empty-interface

/**
 * CO2LevelsOrg figure and legend for the current profile.
 * @param props Properties for component.
 * @returns JSX component.
 */
export const CO2LevelsOrg: FC<CO2LevelsOrgProps> = (props: CO2LevelsOrgProps) => {
  const divRef = useRef<HTMLDivElement>(null)
  const classes = co2LevelsOrgStyle()

  useEffect(() => {
    const script = document.createElement('script')
    script.async = true
    script.src = 'https://www.climatelevels.org/graphs/js/co2.php?theme=default&pid=2degreesinstitute'
    const current = divRef.current
    if (current !== undefined) {
      current?.appendChild(script)
    }
  }, [])
  return (
    <div
      ref={divRef}
      className={classes.root}
    >
      <div id='co2-widget-container' className={classes.container} />
    </div>
  )
}
